import { IRoster } from '@network/models/roster.model'
import { useSelector } from 'react-redux'
import { selectRosters } from 'data/business/Rosters/selectors'

/**
 * Standard roster names that should be auto-selected when no specific rosters are chosen
 */
const DEFAULT_ROSTER_NAMES = ['Favorites', 'Worked Before']

const useDefaultRosterIds = () => {
  const rosters = useSelector(selectRosters)
  const defaultRosters = rosters.filter((roster: IRoster) =>
    DEFAULT_ROSTER_NAMES.includes(roster.name),
  )
  return defaultRosters
}

export { useDefaultRosterIds }
